import { document } from "./window.js";
export const getCookies = () => {
    const cookies = {};
    return document.cookie.split("; ").reduce((obj, current) => {
        const [name, value] = current.split("=");
        obj[name] = value;
        return obj;
    }, cookies);
};
export const getCookie = (name) => getCookies()[name];
export const setCookie = (name, value, maxAge = 31536000) => {
    document.cookie = `${name}=${value};max-age=${maxAge}`;
};
